define([
	"dojo/_base/declare",
	"csi/access/crews",
	"csi/locale",
	"csi/resolver",
	"csi/table/SwitchboardWidget",
	"csi/xml",
	"WBS"
], function (declare, crews, locale, resolver, Widget, xml, WBS) {

	function _isRequestPending(/*Context*/ctx) {
		// summary: return true if request is pending on WbsHolder in context
		var wbsRequest = ctx.cache.getNode(ctx.getParent().WbsRequest);
		return wbsRequest && wbsRequest.RequestStatus == "Pending";
	}

	function _getWbsIfValid(/*Context*/ctx) {
		var wbs = ctx.getNode();
		return (xml.nodeHasRight(wbs, xml.RIGHT_ADMIN) && !_isRequestPending(ctx)) ? wbs : null;
	}

	return declare(Widget, {
		onAccessActionRestart: function (/*Context*/ctx, /*Action*/action) {
			var node = _getWbsIfValid(ctx);
			var state = WBS.getState(node);
			return state == WBS.stateSuspended || state == WBS.stateReplanning;
		},

		onAccessActionSaveAsTemplate: function (/*Context*/ctx, /*Action*/action) {
			var node = _getWbsIfValid(ctx);
			var adminNode = resolver.resolveNode("centric://REFLECTION/INSTANCE/WbsAdmin/BLANK", true);
			return node && xml.nodeHasRight(adminNode, xml.RIGHT_WRITE);
		},

		onAccessActionStart: function (/*Context*/ctx, /*Action*/action) {
			var node = _getWbsIfValid(ctx);
			return WBS.getState(node) == WBS.statePlanned;
		},

		onAccessActionSuspend: function (/*Context*/ctx, /*Action*/action) {
			var node = _getWbsIfValid(ctx);
			return WBS.getState(node) == WBS.stateInProcess;
		},

		onAccessActionSelectWBS: function (/*Context*/ctx, /*Action*/action) {
			return !_isRequestPending(ctx) && crews.isInRoles(["WBS Admin"], ctx.getContextNode());
		},

		_onRootDependencyPaths: function (/*String[]*/paths) {
			// summary: add path for WbsRequest
			paths.push(xml.path("WbsRequest"));
			this.inherited(arguments);
		},

		_buildView: function () {
			// summary: show warning message if WbsRequest is pending
			this.invalidNode.set("bold", true);
			this.invalidNode.set("icon", this.invalidNode.INFO);
			this.invalidNode.set("value", _isRequestPending(this.getContext()) ? locale.resource("WBSPending") : "");
			this.inherited(arguments);
		},

		/**
		 * Refresh the table row and the whole WBS table under Switchboard table
		 * @param {Controller} ac
		 */
		postActionRefreshWBSNodeAndView(ac) {
			this.postActionRefreshNode(ac);
			this.postActionRefreshSwitchboard(ac);
		},

		/**
		 * Hide the New WBS Task Section on Delete when there are no WBS elements
		 * @param {Controller} ac
		 */
		postActionHideNewWBSTask(ac) {
			this.postActionRedrawData(ac);
		},

		/**
		 * Refresh after 'Select WBS' action
		 * @param {Controller} ac
		 */
		postActionRefreshOnNewWBS(ac) {
			const wbsHolder = ac.getParent();
			const wbses = wbsHolder.WBS;

			// refresh the whole table if we have only one WBS.
			// It could be because we don't support multiple WBSes on this type.
			// In this case, 'Select WBS' action will delete old WBS and add a new one.
			// We need to redraw the whole table to remove deleted WBS
			if (wbses.length == 1) {
				this.postActionRedrawData(ac);
			}
		}
	});
});